import GeoJSON from "ol/format/GeoJSON";
import { ReportTileGrid } from "../store/helper";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
  "X-Requested-With": "XMLHttpRequest"
};

export async function fetchProjects(jwt, paging) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  let page = 1;
  let limit = 50;
  if (paging) {
    page = paging.page;
    limit = paging.itemsPerPage;
  }
  const offset = (page - 1) * limit;
  let url =
    process.env.VUE_APP_CRAIYON_API +
    `cAPPdesigner/api/v1/project/?limit=${limit}&offset=${offset}`;

  return (
    await fetch(url, {
      method: "get",
      headers
    })
  ).json();
}

export async function fetchProject(jwt, id) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API + "cAPPdesigner/api/v1/project/" + id,
      {
        method: "get",
        headers
      }
    )
  ).json();
}

export async function fetchUser(jwt) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  return (
    await fetch(process.env.VUE_APP_CRAIYON_API + "cAPPdesigner/api/v1/user", {
      method: "get",
      headers
    })
  ).json();
}

export async function fetchGroups(jwt) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  return (
    await fetch(process.env.VUE_APP_CRAIYON_API + "cAPPdesigner/api/v1/group", {
      method: "get",
      headers
    })
  ).json();
}

export async function addUserToProject(jwt, userId, project) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  const body = JSON.stringify({ id: userId });
  return await fetch(
    process.env.VUE_APP_CRAIYON_API +
      `cAPPdesigner/api/v1/project/${project.id}/user/`,
    {
      method: "post",
      headers,
      body
    }
  );
}

export async function deleteUserFromProject(jwt, userId, project) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await fetch(
    process.env.VUE_APP_CRAIYON_API +
      `cAPPdesigner/api/v1/project/${project.id}/user/?user_id=${userId}`,
    {
      method: "delete",
      headers
    }
  );
}

export async function storeUserManagement(jwt, payload) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
  const body = payload;
  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API + "cAPPdesigner/edit_project_userlists",
      {
        method: "post",
        headers,
        body
      }
    )
  ).json();
}

export async function getCsrfToken(jwt) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return fetch(process.env.VUE_APP_CRAIYON_API + "cAPPdesigner/csrf/", {
    method: "post",
    headers
  });
}

export async function fetchAnnotationClasses(jwt, projectId) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `cAPPdesigner/api/v1/project/${projectId}/annotationclasses`,
      {
        method: "get",
        headers
      }
    )
  ).json();
}

export async function storeAnnotationClass(jwt, annotationClass, projectId) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  let body = "";
  const keys = [
    "class_name",
    "annotation_geometry",
    "color",
    "fill_color",
    "description"
  ];
  for (let key of Object.keys(annotationClass)) {
    if (keys.includes(key))
      body += `${key}=${encodeURIComponent(annotationClass[key])}&`;
  }
  body =
    "formdata=" +
    encodeURIComponent(body) +
    "&project_primaer=" +
    encodeURIComponent(projectId) +
    "&annotation_class_id=" +
    encodeURIComponent(annotationClass.id);
  headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
  let method = "post";
  if (annotationClass.id) {
    method = "put";
  }
  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API + "cAPPdesigner/add_anno_class",
      {
        method,
        headers,
        body
      }
    )
  ).json();
}

export async function deleteAnnotationClass(jwt, annotationClass) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `cAPPdesigner/delete_anno_class?curr_anno_pk=${annotationClass.id}`,
      {
        method: "delete",
        headers
      }
    )
  ).json();
}

export async function createProject(jwt, project) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  let body =
    "project_name=" +
    encodeURIComponent(project.project_name) +
    "&details=" +
    encodeURIComponent(project.details);
  body =
    "formdata=" +
    encodeURIComponent(body) +
    "&project_primaer=" +
    encodeURIComponent(project.id);
  headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
  return (
    await fetch(process.env.VUE_APP_CRAIYON_API + "cAPPdesigner/add_capp", {
      method: "post",
      headers,
      body
    })
  ).json();
}

export async function editProject(jwt, project) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  let body =
    "project_name=" +
    encodeURIComponent(project.project_name) +
    "&details=" +
    encodeURIComponent(project.details);
  body =
    "formdata=" +
    encodeURIComponent(body) +
    "&project_primaer=" +
    encodeURIComponent(project.id);
  headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API + "cAPPdesigner/edit_project_ajax",
      {
        method: "post",
        headers,
        body
      }
    )
  ).json();
}

export async function addWholeSlideImageToProject(jwt, identifier, project) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  const body = JSON.stringify({ identifier });
  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `cAPPdesigner/api/v1/project/${project.id}/slide/`,
      {
        method: "post",
        headers,
        body
      }
    )
  ).json();
}

export async function deleteWholeSlideImage(jwt, project, wsiId) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await fetch(
    process.env.VUE_APP_CRAIYON_API +
      `cAPPdesigner/api/v1/project/${project.id}/slide/?id=${wsiId}`,
    {
      method: "delete",
      headers
    }
  );
}

export async function getSlides(jwt, project, paging) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  let page = 1;
  let limit = 10;
  if (paging) {
    page = paging.page;
    limit = paging.itemsPerPage;
  }
  const offset = (page - 1) * limit;

  let url =
    process.env.VUE_APP_CRAIYON_API +
    `cAPPdesigner/api/v1/project/${project.id}/slide/?limit=${limit}&offset=${offset}`;

  return await (
    await fetch(url, {
      method: "get",
      headers
    })
  ).json();
}

export async function updateSlideStatus(
  jwt,
  newStatus,
  oldStatus,
  annotation_class,
  slide
) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  let body = JSON.stringify({
    status: newStatus,
    annotation_class: annotation_class.id,
    wsi: slide.id
  });
  let url =
    process.env.VUE_APP_CRAIYON_API + `cAPPdesigner/api/v1/slides-status/`;
  let method = "post";
  if (oldStatus !== undefined) {
    url += `${oldStatus.id}/`;
    method = "put";
    body = JSON.stringify({ status: newStatus });
  }

  return await fetch(url, {
    method,
    headers,
    body
  });
}

export async function getSlidesWithStatus(jwt, status) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  const res = await (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `cAPPdesigner/api/v1/slides-status/?status=${status}`,
      {
        method: "get",
        headers
      }
    )
  ).json();

  const projects = [];
  for (let slide of res.results) {
    let projectId = slide.annotation_class.project;
    let project = projects.find(e => e.id === projectId);
    if (!project) {
      project = await fetchProject(jwt, projectId);
      projects.push(project);
    }
    slide.project = project;
  }
  return res;
}

export async function getSlideById(jwt, id) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await (
    await fetch(
      process.env.VUE_APP_CRAIYON_API + `cAPPdesigner/api/v1/slides/${id}`,
      {
        method: "get",
        headers
      }
    )
  ).json();
}

export async function requestAnnotations(
  jwt,
  slide,
  project,
  annotationClasses,
  status
) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  let body = [];
  for (let ac of annotationClasses) {
    body.push({ annotation_class_id: ac.id, status });
  }
  body = JSON.stringify(body);

  let url =
    process.env.VUE_APP_CRAIYON_API +
    `cAPPdesigner/api/v1/project/${project.id}/slide/?id=${slide.wsi.id}`;

  return await fetch(url, {
    method: "put",
    headers,
    body
  });
}

export async function getSlidesToAnnotate(jwt) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `cAPPdesigner/api/v1/slides-to-annotate`,
      {
        method: "get",
        headers
      }
    )
  ).json();
}

export async function storeAnnotation(jwt, annotation) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  const body = JSON.stringify({
    wsiId: annotation.wsiId,
    slide: annotation.slide,
    geometry: new GeoJSON().writeFeature(annotation.geometry, { decimals: 2 }),
    annotationClassId: annotation.annotationClassId,
    description: annotation.description,
    project_id: annotation.project
  });
  return await (
    await fetch(process.env.VUE_APP_CRAIYON_API + `slides/add_annotation`, {
      method: "post",
      headers,
      body
    })
  ).json();
}

export async function fetchAnnotationsWithStatus(
  jwt,
  project,
  status,
  paging = {}
) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  let page = paging.page || 1;
  let limit = paging.itemsPerPage || 20;
  let offset = (page - 1) * limit;
  const res = await (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `slides/api/annotation/?status=${status}&project=${project.id}&limit=${limit}&offset=${offset}`,
      {
        method: "get",
        headers
      }
    )
  ).json();
  return {
    paging: {
      next: res.next,
      previous: res.previous,
      total: res.count
    },
    result: res.results
  };
}

export async function getAnnotationsForSlide(jwt, wsiId) {
  // TODO read all pages for paginated result
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  const res = await (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `slides/api/annotation/?wsi_id=${wsiId}`,
      {
        method: "get",
        headers
      }
    )
  ).json();
  return res.results;
}

export async function setAnnotationStatus(jwt, status, fhirId, rejectReason) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  let body = {
    fhirId,
    status,
    rejectReason
  };
  console.log(body);
  body = JSON.stringify(body);

  return await fetch(
    process.env.VUE_APP_CRAIYON_API + `slides/api/annotation/update_status/`,
    {
      method: "put",
      headers,
      body
    }
  );
}

export async function deleteAnnotation(jwt, id) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await fetch(
    process.env.VUE_APP_CRAIYON_API + `slides/api/annotation/${id}/delete`,
    {
      method: "delete",
      headers
    }
  );
}

export async function extractROIs(jwt, slide, ids, project) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  let body = {
    wsi: {
      id: slide.id,
      classes: ids
    },
    project: project.id
  };
  body = JSON.stringify(body);

  return await fetch(
    process.env.VUE_APP_CRAIYON_API + `slides/api/roi-extraction/`,
    {
      method: "post",
      headers,
      body
    }
  );
}

export async function fetchRoiExtractions(jwt, project) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `slides/api/roi-extraction/?project=${project.id}`,
      {
        method: "get",
        headers
      }
    )
  ).json();
}

export async function register(data) {
  return await fetch(
    process.env.VUE_APP_CRAIYON_API + `user_management/api/registration`,
    {
      method: "post",
      headers,
      body: JSON.stringify(data)
    }
  );
}

export async function getTokenBalance(jwt) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await (
    await fetch(
      process.env.VUE_APP_CRAIYON_API + `user_management/api/balance`,
      {
        method: "get",
        headers
      }
    )
  ).json();
}

export async function getTokenLog(jwt) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await (
    await fetch(
      process.env.VUE_APP_CRAIYON_API + `user_management/api/token-log`,
      {
        method: "get",
        headers
      }
    )
  ).json();
}

export async function getAnnotationsOfUser(jwt) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await (
    await fetch(process.env.VUE_APP_CRAIYON_API + `slides/api/annotation/my`, {
      method: "get",
      headers
    })
  ).json();
}

export async function getWalletInfo(jwt) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return await (
    await fetch(
      process.env.VUE_APP_CRAIYON_API + `user_management/api/wallet-info`,
      {
        method: "get",
        headers
      }
    )
  ).json();
}

export async function fetchReportBatches(jwt, paging) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  let page = 1;
  let limit = 50;
  if (paging) {
    page = paging.page;
    limit = paging.itemsPerPage;
  }
  const offset = (page - 1) * limit;
  let url =
    process.env.VUE_APP_CRAIYON_API +
    `cdss/api/v1/reportbatch/?limit=${limit}&offset=${offset}`;
  return (
    await fetch(url, {
      method: "get",
      headers
    })
  ).json();
}

export async function fetchDiagnosis(jwt) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  let url = process.env.VUE_APP_CRAIYON_API + `cdss/api/v1/label/`;
  return (
    await fetch(url, {
      method: "get",
      headers
    })
  ).json();
}

export async function fetchReportDiagnosis(jwt, id) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  let url =
    process.env.VUE_APP_CRAIYON_API +
    `cdss/api/v1/reportwsi/${id}/reportdiagnosis`;
  return (
    await fetch(url, {
      method: "get",
      headers
    })
  ).json();
}

export async function fetchReportWSI(jwt, id) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API + "cdss/api/v1/reportwsi/" + id,
      {
        method: "get",
        headers
      }
    )
  ).json();
}

export async function fetchReportTileGrid(jwt, id) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `cdss/api/v1/reportwsi/${id}/reporttilegrid`,
      {
        method: "get",
        headers
      }
    )
  ).json();
}
export async function updateReportTileGrid(jwt, reportTileGrid) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return (
    await fetch(
      process.env.VUE_APP_CRAIYON_API +
        `cdss/api/v1/reportwsi/${reportTileGrid.reportwsi}/reporttilegrid/`,
      {
        method: "put",
        headers,
        body: JSON.stringify(reportTileGrid)
      }
    )
  ).json();
}

export async function createReportBatch(jwt, reportBatch) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  return (
    await fetch(process.env.VUE_APP_CRAIYON_API + "cdss/api/v1/reportbatch", {
      method: "post",
      headers,
      body: JSON.stringify(reportBatch)
    })
  ).json();
}
